<template>
  <el-dialog
    :visible.sync="visible"
    title="合同费用管理"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :append-to-body="true"
    width="70%"
  >
    <el-form
      :inline="true"
      :model="dataForm"
      @keyup.enter.native="getDataList()"
    >
      <el-form-item label="费用名称：">
        <el-input
          v-model="dataForm.name"
          placeholder="请输入费用名称"
          clearable
          size="mini"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click="getDataList()" size="mini">{{ $t("query") }}</el-button>
      </el-form-item>
      <el-form-item>
        <el-button
          v-if="$hasPermission('trade:cost:save')"
          type="primary"
          size="mini"
          @click="addOrUpdateHandle()"
          >{{ $t("add") }}</el-button
        >
      </el-form-item>
    </el-form>
    <el-table
      v-loading="dataListLoading"
      :data="dataList"
      border
      @selection-change="dataListSelectionChangeHandle"
      style="width: 100%;"
      max-height="300"
    >
      <el-table-column
        type="index"
        label="行号"
        header-align="center"
        align="center"
        width="50"
      ></el-table-column>
      <el-table-column
        prop="name"
        label="费用名"
        header-align="center"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="categoryName"
        label="费用科目"
        header-align="center"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="amount"
        label="金额"
        header-align="center"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="operateTime"
        label="发生时间"
        header-align="center"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="creatorName"
        label="操作人"
        header-align="center"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="createDate"
        label="操作时间"
        header-align="center"
        align="center"
        width="160"
      ></el-table-column>
      <el-table-column
        :label="$t('handle')"
        fixed="right"
        header-align="center"
        align="center"
        width="150"
      >
        <template slot-scope="scope">
          <el-button
            v-if="$hasPermission('trade:cost:update')"
            type="text"
            size="small"
            @click="addOrUpdateHandle(scope.row.id)"
            >{{ $t("update") }}</el-button
          >
          <el-button
            v-if="$hasPermission('trade:cost:delete')"
            type="text"
            size="small"
            @click="deleteHandle(scope.row.id)"
            >{{ $t("delete") }}</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="page-box">
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle"
      >
      </el-pagination>
    </div>
  </el-dialog>
</template>

<script>
import mixinViewModule from "@/mixins/view-module";
export default {
  mixins: [mixinViewModule],
  data() {
    return {
      visible: false,
      mixinViewModuleOptions: {
        getDataListURL: "/trade/cost/page",
        getDataListIsPage: true,
        exportURL: "/trade/cost/export",
        deleteURL: "/trade/cost",
        deleteIsBatch: true,
        activatedIsNeed: false,
      },
      dataForm: {
        agreementId: "",
      },
    };
  },
  methods: {
    init() {
      this.visible = true;
      this.reload();
    },
  },
  components: {
  },
};
</script>
